import React, { useEffect, useState } from 'react'
import styles from "./cartProduct.module.css"
import { IoClose } from "react-icons/io5";
import { LuImage } from "react-icons/lu";
import { FaPlus, FaMinus } from "react-icons/fa6";
import { getProductVariantImage } from "../../states/ProductStore";
const DEFAULT_CLASSES = {
  container: styles.cardContainer,
  imageContainer: styles.imageContainer,
  image: styles.image,
  imagePlaceholder: styles.placeholder,
  info: styles.info,
  header: styles.header,
  details: styles.details,
  name: styles.name,
  description: styles.description,
  deleteButton: styles.deleteButton,
  footer: styles.footer,
  quantityControls: styles.quantityControls,
  quantityButton: styles.quantityButton,
  quantity: styles.quantity,
  price: styles.price
};

export default function CartProduct({
  item,
  handleIncreaseQuantity = () => {},
  handleDecreaseQuantity = () => {},
  handleRemoveItem = () => {},
  onClick = () => {},
  cartProductClassesOverride = {},
  cartProductStyles = {}
}) {
  const classes = { ...DEFAULT_CLASSES, ...cartProductClassesOverride };
  const variantAttributes = item.product_variant?.attributes ?? [];
  const size = variantAttributes.find((attribute) => attribute.name?.toLowerCase() === 'size')?.value;
  const color = variantAttributes.find((attribute) => attribute.name?.toLowerCase() === 'color')?.value;
  const imageSource = getProductVariantImage(
    item.product_variant?.product,
    item.product_variant,
    color
  );
  const [imageFailed, setImageFailed] = useState(false);

  useEffect(() => {
    setImageFailed(false);
  }, [imageSource]);

  return (
    <div className={classes.container} style={cartProductStyles.container} onClick={onClick}>
        <div className={classes.imageContainer} style={cartProductStyles.imageContainer}>
          {imageSource && !imageFailed ? (
            <img
              src={imageSource}
              alt={item.product_variant.product.name}
              className={classes.image}
              style={cartProductStyles.image}
              onError={() => setImageFailed(true)}
            />
          ) : (
            <LuImage
              size={48}
              className={classes.imagePlaceholder}
              style={cartProductStyles.imagePlaceholder}
            />
          )}
        </div>

        <div className={classes.info} style={cartProductStyles.info}
          onClick={onClick}
        >
          <div className={classes.header} style={cartProductStyles.header}>
            <div className={classes.details} style={cartProductStyles.details}>
              <h3 className={classes.name} style={cartProductStyles.name}>{item.product_variant?.product?.name}</h3>
              <p className={classes.description} style={cartProductStyles.description}>{item.product_variant?.product?.description}</p>
              {(color || size) && (
                <p className={classes.description} style={cartProductStyles.description}>
                  {color ? `Color: ${color}` : ''}{color && size ? ' • ' : ''}{size ? `Size: ${size}` : ''}
                </p>
              )}
            </div>

            <button className={classes.deleteButton} style={cartProductStyles.deleteButton} onClick={(e) => { e.stopPropagation(); handleRemoveItem(item.id); }}>
              <IoClose size={20} />
            </button>
          </div>

          <div className={classes.footer} style={cartProductStyles.footer}>

            <div className={classes.quantityControls} style={cartProductStyles.quantityControls}>
              {item.quantity > 1 ? (
                <button className={classes.quantityButton} style={cartProductStyles.quantityButton} onClick={(e) => { e.stopPropagation(); handleDecreaseQuantity(item.id); }}><FaMinus size={12} /></button>
              ) : (
                <button className={classes.quantityButton} style={cartProductStyles.quantityButton} onClick={(e) => { e.stopPropagation(); handleRemoveItem(item.id); }}>remove</button>
              )}
              <span className={classes.quantity} style={cartProductStyles.quantity}>Qty: {item.quantity}</span>
              <button className={classes.quantityButton} style={cartProductStyles.quantityButton} onClick={(e) => { e.stopPropagation(); handleIncreaseQuantity(item.id); }}><FaPlus size={12} /></button>
            </div>

            <span className={classes.price} style={cartProductStyles.price}>
              $
              {(
                (item.product_variant?.price_cents || 0) / 100
              ).toFixed(2)}
            </span>

            
          </div>
        </div>
    </div>
  )
}
